import React from 'react';

export default function ImplBlock1Hero() {
  return (
    <section className="py-20 md:py-32 px-6 md:px-16 bg-paper text-ink overflow-hidden relative">
      <div className="max-w-4xl mx-auto relative z-10 flex flex-col items-center text-center w-full">
        <div className="text-[12px] font-semibold tracking-widest uppercase text-brand mb-8">
          Implementación
        </div>
        <h1 className="text-[40px] sm:text-[48px] md:text-[64px] lg:text-[72px] font-bold tracking-tight leading-[1.1] mb-8 w-full">
          Instalar capacidad operacional sin reemplazar lo que tu red ya tiene.
        </h1>
        <p className="text-[18px] md:text-[22px] text-ink-soft mb-12 leading-[1.6] max-w-3xl">
          BAC opera sobre las fuentes, reglas, capacidad y canales acordados con la red. Organiza la operación poblacional mientras los equipos APS mantienen la ejecución clínica.
        </p>
        <a href="/#contacto" className="inline-block bg-brand text-white hover:bg-brand/90 px-8 py-4 text-[14px] font-semibold rounded-xl transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white whitespace-nowrap">
          CONVERSEMOS
        </a>
      </div>
    </section>
  );
}
